import React, { Component } from 'react';
import { IMetricsTableRow, IMetricsTableBody } from '../MetricsTable';
import { MetricsTableBodyContainer, MetricsTableRow, MetricsTableRowNull } from './MetricsTableBody.styled';

import MetricsTableTitleCell from './MetricsTableTitleCell/MetricsTableTitleCell';
import MetricsTableFormattedCell from './MetricsTableFormattedCell/MetricsTableFormattedCell';
import MetricsTableChartCell from './MetricsTableChartCell/MetricsTableChartCell';

export default class MetricsTableBody extends Component<IMetricsTableBody, {}> {
   getRowCells = (row: IMetricsTableRow, scale, windowSize, showData) => {
      const formattedCells = row
         ? row.Values.map((value, i) => {
              return (
                 <MetricsTableFormattedCell
                    key={i}
                    value={value}
                    precision={row.Precision}
                    type={row.Type}
                    showData={showData}
                    scale={scale}
                    level={row.Level}
                 />
              );
           })
         : 'N/A';

      // if (windowSize.isExtraSmall) {
      //    return formattedCells.slice(0, 2);
      // } else if (windowSize.isSmall) {
      //    return formattedCells.slice(0, 3);
      // } else {
      return formattedCells;
      // }
   };

   public render() {
      const { rows, scale, windowSize, showData, toggleRow, maxReached } = this.props;
      const tableRows = rows ? (
         rows.map((row, index) => {
            if (row.HasData) {
               return (
                  <MetricsTableRow key={row.Row} index={index} rowStyle={row.Style}>
                     <MetricsTableTitleCell level={row.Level} title={row.TableTitle} />
                     {this.getRowCells(row, scale, windowSize, showData)}
                     <MetricsTableChartCell id={row.Id} row={row.Row} isCharted={row.Charted} maxReached={maxReached} toggleChartedRow={toggleRow} />
                  </MetricsTableRow>
               );
            }
            return (
               <MetricsTableRowNull key={row.Row} rowStyle={row.Style}>
                  <MetricsTableTitleCell level={row.Level} title={row.TableTitle} />
               </MetricsTableRowNull>
            );
         })
      ) : (
         <tr />
      );

      return <MetricsTableBodyContainer>{tableRows}</MetricsTableBodyContainer>;
   }
}
